import React, { useContext, useEffect, useState } from "react"
import { ContainerStackScreen } from "@Components/ContainerStackScreen"
import { Button } from "@Components/CustomButton/Button"
import { BreeSerifText } from "@Components/CustomText/BreeSerifText"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { Spacer } from "@Components/Space"
import { ShowToast } from "@Components/ToastNotification/ToastNotification"
import { baseColors } from "@Constants/baseStyles"
import { message } from "@Constants/constant"
import { GoalContext } from "@Providers/GoalProvider"
import { needUpdateGoalAtom } from "@Recoil/Atom/goalAtom"
import { GoalService } from "@Services/Goals.Service"
import { ScrollView, StyleSheet, View } from "react-native"
import ProgressCircle from "@Components/PercentageCircle"
import { useRecoilState } from "recoil"
import MultiSlider from "@ptomasroos/react-native-multi-slider"
import { handleSetColor } from "./Goal.Utils"

export const GoalDetails = ({ navigation, route }) => {
    const goalData = route.params?.goal
    const [goal, setGoal] = useState(goalData)
    const [loading, setLoading] = useState(false)
    const [sliderValue, setSliderValue] = useState(1)
    const [needUpdateGoal, setNeedUpdateGoal] = useRecoilState(needUpdateGoalAtom)
    const { setUpdateGoals } = useContext(GoalContext)
    const finished = () => navigation.navigate("GoalFinished")
    const isOneTime = goal?.numTimeValidation === 1

    useEffect(() => {
        if (goal?.numTimeValidation === goal?.numValidated) {
            finished()
        }
    }, [goal])

    const payload = {
        name: goal?.name ?? "",
        numTimeValidation: goal?.numTimeValidation ?? 0,
        numValidated: isOneTime ? sliderValue : goal?.numValidated + 1,
        state: isOneTime ? 2 : goal?.state?.id,
        patientId: goal?.patient?.id,
        axisId: goal?.axis?.id,
        timeValidationUnit: goal?.timeValidationUnit
    }

    const btnLabel = isOneTime ? "Valider" : "Valider une semaine"

    const performUpdate = () => {
        setLoading(true)
        try {
            if (goal?.id > 0) {
                GoalService.update(goal?.id, payload)
                    .then((response) => {
                        const data = response.data?.data
                        setGoal(data)
                        ShowToast({ type: "success", message: "Opération réussie !" })
                        setLoading(false)
                        setNeedUpdateGoal(!needUpdateGoal)
                        setUpdateGoals((prev) => !prev)
                        if (isOneTime) {
                            finished()
                        }
                    })
                    .catch((e) => {
                        ShowToast({ type: "error", message: message.serverError })
                        setLoading(false)
                    })
            }
        } catch (error) {
            ShowToast({ type: "error", message: "Objectif non définit" })
        }
    }

    const handleChangeSlide = (texValue) => {
        const rounded = Math.round(texValue)
        setSliderValue(rounded)
    }

    return (
        <ContainerStackScreen>
            <Spacer />
            <ScrollView>
                <BreeSerifText textAlign={"center"} fontSize={24} color={baseColors.green.primary}>
                    {goal?.name}
                </BreeSerifText>

                <Spacer height={40} />

                <View style={[styles.progressCircleContainer, {}]}>
                    {!isOneTime ? (
                        <ProgressCircle
                            percent={(goal?.numValidated / goal?.numTimeValidation) * 100}
                            radius={60}
                            borderWidth={12}
                            color={baseColors.green.dark}
                            shadowColor={baseColors.green.light}
                            bgColor={baseColors.white}
                        >
                            <OpenSansText
                                style={{ color: baseColors.green.primary, fontSize: 26 }}
                            >{`${goal?.numValidated} / ${goal?.numTimeValidation}`}</OpenSansText>
                        </ProgressCircle>
                    ) : (
                        <View style={{ flex: 1, flexDirection: "row", alignItems: "center", marginBottom: -50 }}>
                            <View
                                style={{ flex: 1 / 3, justifyContent: "center", alignItems: "center", width: "100%" }}
                            >
                                <MultiSlider
                                    vertical
                                    snapped
                                    allowOverlap={false}
                                    onValuesChange={(value) => handleChangeSlide(value[0])}
                                    values={[sliderValue]}
                                    touchDimensions={styles.touchDimensions}
                                    selectedStyle={{ backgroundColor: baseColors.green.dark }}
                                    trackStyle={{
                                        backgroundColor: baseColors.green.pastel,
                                        height: 10,
                                        borderRadius: 5
                                    }}
                                    markerStyle={{
                                        // borderWidth: 5,
                                        // borderColor: baseColors.green.dark
                                        backgroundColor: handleSetColor(sliderValue),
                                        borderColor: handleSetColor(sliderValue),
                                        height: 50,
                                        width: 20
                                    }}
                                    minMarkerOverlapStepDistance={0}
                                    minMarkerOverlapDistance={0}
                                    // customMarker={(e) => (
                                    //     <View
                                    //         style={{
                                    //             flexDirection: "row",
                                    //             paddingTop: 10,
                                    //             backgroundColor: "red"
                                    //         }}
                                    //     >
                                    //         <View
                                    //             style={{
                                    //                 height: 50,
                                    //                 width: 20,
                                    //                 borderRadius: 10,
                                    //                 backgroundColor: handleSetColor(Math.round(e.currentValue)),
                                    //                 borderColor: handleSetColor(Math.round(e.currentValue)),
                                    //                 borderWidth: 5
                                    //             }}
                                    //         />
                                    //     </View>
                                    // )}
                                    min={1}
                                    max={5}
                                    step={1}
                                />
                            </View>

                            <View style={styles.valuesContainer}>
                                <OpenSansText style={{ color: "green" }} fontSize={18}>
                                    Atteint
                                </OpenSansText>
                                <View style={{ height: 60, width: 30 }} />
                                {/* <OpenSansText style={{ color: "yellow" }} fontSize={18}>
                                Quasi atteint
                            </OpenSansText> */}
                                <OpenSansText style={{ color: "orange" }} fontSize={18}>
                                    Partiellement atteint
                                </OpenSansText>
                                {/* <OpenSansText style={{ color: "red" }} fontSize={18}>
                                En cours
                            </OpenSansText> */}
                                <View style={{ height: 60, width: 30 }} />
                                <OpenSansText style={{ color: "purple" }} fontSize={18}>
                                    Pas atteint
                                </OpenSansText>
                            </View>
                        </View>
                    )}
                </View>
            </ScrollView>

            <View style={{}}>
                <Button
                    text={btnLabel}
                    width="80%"
                    loading={loading}
                    disabled={goal?.numValidated === goal?.numTimeValidation || loading}
                    onPress={performUpdate}
                    backgroundColor={baseColors.green.primary}
                    labelColor="white"
                />
            </View>
        </ContainerStackScreen>
    )
}

const styles = StyleSheet.create({
    touchDimensions: {
        height: 25,
        width: 25,
        borderRadius: 10
    },
    progressCircleContainer: {
        marginTop: 30,
        marginLeft: 60,
        justifyContent: "center",
        alignContent: "center",
        alignItems: "center",
        alignSelf: "center"
    },
    valuesContainer: {
        flexDirection: "column",
        justifyContent: "space-between",
        left: -10,
        height: 290
    }
})
